var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTurnoffIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "data-supported-dps": "24x24",
    fill: "currentColor",
    className: "mercado-match",
    width: 24,
    height: 24,
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2.71l4 4a5.06 5.06 0 00-.18.77L5 13l-1.83 2.17A4.52 4.52 0 002 18v1h8.28a2 2 0 103.44 0h4.57l3 3 .71-.71L2.71 2zm5.68 5.67L12.29 13H7zM13.29 14l3 3h-12c.12-.19.24-.37.38-.55L6.77 14zM22 18v1h-.88l-1.2-1.2a2.4 2.4 0 00-.65-1.38l-2-2.42h-1.15l-1-1H17l-.76-5.28A4.27 4.27 0 0012 4a4.26 4.26 0 00-3.71 2.17L6.85 4.73A6.25 6.25 0 0112 2a6.27 6.27 0 016.21 5.44L19 13l1.82 2.17A4.53 4.53 0 0122 18z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnoffIcon);
export default __webpack_public_path__ + "static/media/turnoff-icon.36f9c148a6d7f78c754cdce3d0f490ce.svg";
export { ForwardRef as ReactComponent };